import { FaqEntry } from '@/lib/entities/seo';

import Spoiler from '@/lib/shared/components/Spoiler/Spoiler';
import { H2, P1 } from '@/lib/shared/components/Typography';
import { polyfillInterweaveOnServer } from '@/lib/shared/utils/interweave-ssr-polyfill';

import { Markup } from 'interweave';
import { useTranslation } from 'next-i18next';

import styles from './catalog-faq.module.scss';

polyfillInterweaveOnServer();
type Props = {
  faq: FaqEntry[] | null;
};

export const CatalogFaq = ({ faq }: Props) => {
  const { t } = useTranslation('index', { keyPrefix: 'faq' });
  if (!faq) {
    return null;
  }
  const visibleFaq = faq.filter((entry) => entry.isVisible);
  if (visibleFaq.length === 0) {
    return null;
  }
  return (
    <aside className="py-15 tw-container">
      <H2>{t('title')}</H2>
      <dl className="mt-8 gap-7.5 flex flex-col">
        {visibleFaq.map(({ question, answer }, index) => {
          return (
            <Spoiler
              as="dl"
              key={index}
              headerClassName="pb-7.5!"
              toggleIcon="chevron"
              header={
                <span>
                  <P1 as="dt">{question}</P1>
                </span>
              }
            >
              <Markup
                content={answer}
                className={`${styles.p3} ${styles.answer}`}
                tagName="dd"
              />
            </Spoiler>
          );
        })}
      </dl>
    </aside>
  );
};
